import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import AuthIntake from './AuthIntake';
import EligAndClaim from './EligAndClaim';
import CCR from './CCR';

ReactDOM.render(
  <React.StrictMode>
    <AuthIntake />
  </React.StrictMode>,
  document.getElementById('root')
);
